import styled from "styled-components";
import { Row } from "antd";
import { GhostButtonComponent } from "../../../../commonStyles";

export const SubmissionWrapper = styled(Row)`
  padding-bottom: 297px;
  @media only screen and (max-width: 991px) {
    padding-bottom: 175px;
  }
`;

export const SubmissionHeader = styled.h2`
  color: #022737;
  margin: 0px;
  font-family: BerkeleyStd-Book;
  font-size: 36px;
  line-height: 1.17;
  letter-spacing: 0.5px;
  @media only screen and (max-width: 991px) {
    font-size: 30px;
    line-height: 1.2;
  }
`;

export const SubmissionPara = styled.p`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  width: 447px;
  padding-bottom: 50px;
  margin: 0px;
  @media only screen and (max-width: 991px) {
    width: 100%;
    padding-bottom: 40px;
    font-size: 14px;
    line-height: 1.43;
  }
`;

export const SubmitButton = styled.div`
  @media only screen and (max-width: 767px) {
    font-size: 18px;
    width: 100% !important;
  }
  @media only screen and (max-width: 991px) {
    font-size: 18px;
    width: 200px;
  }
`;

export const TickMarkContainer = styled.div`
  margin: 50px 0 30px 0;
  @media only screen and (max-width: 991px) {
    margin: 40px 0 20px 0;
  }
`;

export const TickMark = styled.div`
  border-radius: 50%;
  margin: 0px 20px 0px 0px;
  width: 50px;
  height: 50px;
  border: 2px solid #a8b400;
  ::after {
    position: absolute;
    content: "";
    height: 28px;
    width: 2px;
    background: #a8b400;
    transform: translate(26px, 10px) rotate(45deg);
  }

  ::before {
    position: absolute;
    content: "";
    height: 10px;
    width: 2px;
    background: #a8b400;
    transform: translate(13px, 25px) rotate(135deg);
  }
`;
